export default __webpack_public_path__ + "static/direct-ordering-c94b41485086f7ddb719e2149af7ed4b.gif";